import { useField } from 'formik'
import React, { FC } from 'react'
import { CSSTransition } from 'react-transition-group'
import Tooltip from '../Tooltip/Tooltip'

import styles from './FieldError.module.scss'

interface IProps {
  name: string
  withHorizontalTooltip?: boolean
}

const FieldError: FC<IProps> = ({ name, withHorizontalTooltip }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, meta] = useField(name)
  const { error, touched } = meta

  return (
    <CSSTransition
      mountOnEnter
      unmountOnExit
      in={error && touched}
      timeout={200}
      classNames={{
        appear: styles.error_appear,
        enter: styles.error_enter,
        enterActive: styles.error_enter_active,
        enterDone: styles.error_done,
        exit: styles.error_exit,
        exitActive: styles.error_exit_active,
      }}
    >
      <div className={styles.error}>
        <Tooltip horizontal={withHorizontalTooltip}>{error}</Tooltip>
      </div>
    </CSSTransition>
  )
}

export default FieldError
